import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import i18n from 'i18next';

const HELP_CENTER_PATHS = {
  faq: 'preguntas-frecuentes',
  videos: 'videos',
  manuals: 'manuales',
  courses: 'cursos',
};

const buildHelpCenterUrl = (path, encodeUrl) => {
  const base = (window.REACT_HELP_CENTER || '').replace(/\/$/, '');
  return `${base}/${path}/?idEntrada=${encodeUrl}`;
};

class HelpCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHelpCenter: false
    };
  }

  render() {
    const { showHelpCenter } = this.state;
    const { encodeUrl } = this.props;
    return (
      <Fragment>
        <div className="help-center">
          <img
            src="/assets/icons/header/help.svg"
            alt="help"
            className="lf-icon lf-icon-help 'lf-icon-help"
            onClick={() => {
              this.setState({ showHelpCenter: true });
            }}
          />

          <Modal
            show={showHelpCenter}
            onHide={() => {
              this.setState({ showHelpCenter: false });
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="help-center-modal"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <img
                  src="/assets/icons/lexon/close.svg"
                  alt="close"
                  onClick={() => this.setState({ showHelpCenter: false })}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="card-support-container">
                <div className="card-support card-support-contacts">
                  <strong
                    className="
                    inter-bold-24
                    text-color-highlight-200
                    title-card-support"
                  >
                    {i18n.t('support_center.contact_us')}
                  </strong>
                  <div className="card-info-container support-mail-container">
                    <img
                      src='/assets/icons/lexon/mail.svg'
                      className="lf-icon lf-icon-mail icon-supports mb-3"
                      alt="mail"
                    />
                    <span className="inter-medium-18 text-color-blue-lefebvre">
                      {i18n.t('support_center.lefebvre_email')}
                    </span>
                  </div>
                  <div className="card-info-container">
                    <img
                      src='/assets/icons/lexon/phone.svg'
                      className="lf-icon lf-icon-phone icon-supports mb-3"
                      alt="phone"
                    />
                    <span className="inter-medium-18 mb-2 text-color-blue-lefebvre">
                      {i18n.t('support_center.number_phone')}
                    </span>
                    <span className="inter-regular-16 text-color-grey-600">
                      {i18n.t('support_center.call_hour')}
                    </span>
                  </div>
                </div>
                <div className="card-support card-support-help-center">
                  <strong className="inter-bold-24 text-color-highlight-200 mb-4">
                    {i18n.t('support_center.help_center')}
                  </strong>
                  <div
                    className="card-help-center mb-3 cursor-pointer"
                    onClick={() =>
                      window.open(buildHelpCenterUrl(HELP_CENTER_PATHS.faq, encodeUrl), '_blank')
                    }
                  >
                    <span className="inter-medium-18 text-color-blue-lefebvre">
                      {i18n.t('support_center.frequent_questions')}
                    </span>
                  </div>
                  <div
                    className="card-help-center mb-3 cursor-pointer"
                    onClick={() =>
                      window.open(buildHelpCenterUrl(HELP_CENTER_PATHS.videos, encodeUrl), '_blank')
                    }
                  >
                    <span className="inter-medium-18 text-color-blue-lefebvre">
                      {i18n.t('support_center.videos')}
                    </span>
                  </div>
                  <div
                    className="card-help-center mb-3 cursor-pointer"
                    onClick={() =>
                      window.open(buildHelpCenterUrl(HELP_CENTER_PATHS.manuals, encodeUrl), '_blank')
                    }
                  >
                    <span className="inter-medium-18 text-color-blue-lefebvre">
                      {i18n.t('support_center.manuals')}
                    </span>
                  </div>
                  <div
                    className="card-help-center cursor-pointer"
                    onClick={() =>
                      window.open(buildHelpCenterUrl(HELP_CENTER_PATHS.courses, encodeUrl), '_blank')
                    }
                  >
                    <span className="inter-medium-18 text-color-blue-lefebvre">
                      {i18n.t('support_center.courses')}
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  lexon: state.lexon
});

export default connect(mapStateToProps)(HelpCenter);
